'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'SrcCategoryRestService',
    function ($modal, SrcCategoryRestService) {

        return {
            edit: edit,
            create: create,
            api: SrcCategoryRestService
        };

        function create(items) {
            return $modal.open({
                template: require('../view/src-category-modal-create.html'),
                controller: 'SrcCategoryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    srcCategory: function () {
                        return {};
                    },
                    srcCategories: function () {
                        return items;
                    }
                }
            });
        }

        function edit(item, items) {
            return $modal.open({
                template: require('../view/src-category-modal-create.html'),
                controller: 'SrcCategoryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    srcCategory: function () {
                        return item;
                    },
                    srcCategories: function () {
                        return items;
                    }
                }
            });
        }

    }];